import React from 'react'

const ManagePaymentMethods = () => {
  return (
   <h1> <div>ManagePaymentMethods</div></h1>
  )
}

export default ManagePaymentMethods









// import {getCompanyListMaster,getoutletListMaster,PaymentList
//      } from "../../../../apiservicescall/api";
//   import React, {
//     Fragment,
//     useState,
//     useEffect,
//     useRef,
//     useMemo,
//     useCallback,
//   } from "react";


// import {
//     Table,
//     Badge,
//     Row,
//     Card,
//     Col,
//     Button,
//     Container,
//     ListGroup,
//     Tab,
//   } from "react-bootstrap";
//   import Select from "react-select";
//   import {
//     Pagination,
//     PaginationItem,
//     PaginationLink,
//     Modal,
//     ModalHeader,
//     ModalBody,
//     ModalFooter,
//   } from "reactstrap";
//   import { CardTitle, CardBody } from "reactstrap";
// import Multiselect from "multiselect-react-dropdown";

// const ManagePaymentMethods = () => {

//     const [companyMaster, setCompanyMaster] = useState([]);
//     const [outletvalue, setOutletvalue] = useState([{ label: "", value: "", }]);
//     const [restarantvalue, setRestarantvalue] = useState([{ label: "", value: "", }]);
//     const [outletMasterlist, setOutletMasterlist] = useState([]);

//     const[paymentlistmaster,setPaymentlistmaster]=useState([]);
//     const [paymentfetchitem, setPaymentfetchitem] = useState([]);

//     useEffect(() => {
//         getcompanyMasterList();

//     }, []);
// console.log();


//     const getcompanyMasterList = useCallback(async () => {
//        // debugger
//         let getoutletList = await getCompanyListMaster();
//         let getoutletListValue = getoutletList?.data?.data;
//         let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
//           label: compName,
//           value: compCode,
//         }));
//         console.log("companyoutmaster",companyoutmaster);
//         setCompanyMaster(companyoutmaster);
//         setOutletvalue({
//           label: getoutletListValue[0]?.compName,
//           value: getoutletListValue[0]?.compCode,
//         });
//         getoutletMasterList(getoutletListValue[0]?.compCode);
//       }, []);

      

     
//       const getoutletMasterList = async (companyCode) => {
//         let getoutletList = await getoutletListMaster(companyCode);
//         let getoutletListValue = getoutletList?.data?.data;
//         let companyoutmaster = getoutletListValue
//           && getoutletListValue.map(({ outletCode, outletName }) => ({
//             label: `${outletCode}-${outletName}`,
//             value: outletCode,
//           }));
//         console.log("companyoutmaster", companyoutmaster);
//         setOutletMasterlist(companyoutmaster);
//       };
    

//       const getpaymentmasterlist = async ( outletCode) => {
//         let getslotList = await PaymentList(outletCode);
//         let getslotListValue = getslotList?.data?.data || [];
//         setPaymentfetchitem(getslotListValue);
//         setPaymentlistmaster(getslotListValue);

//         console.log("getslotListValue",getslotListValue);
//         // let searchfieldvalue = "dd";
//         // let filteredMenuItemList =
//         //   getslotListValue &&
//         //   getslotListValue.filter(
//         //     (item) =>
//         //       item.itemDesc.substring(0, 1) == searchfieldvalue.substring(0, 1)
//         //   );
//       };





//   return (
//    <>
//    <div className="row">
//    <Card>
//    <Card.Header className="card-title">

//    <div class="col-sm col-md-1 form-group">
//                 <h3 className="me-auto" style={{ fontFamily: "Roboto", color: "darkgreen" }}>
//                   Payment
//                 </h3>
//               </div>

//               <div class="col-sm col-md-4 form-group" style={{ padding: "inherit" }} >
//                 <label as="a" variant="badge badge-rounded badge-danger">
//                   Company
//                 </label>
//                 <Select
//                   options={companyMaster}
//                   value={outletvalue}
//                   closeMenuOnSelect={false}
//                   search
//                   name="stateCode"
//                   placeholder="Choose"
//                   autoComplete="off"
//                   onChange={(event) => {
                   
//                     setRestarantvalue({ label: "", value: "" });
//                     setOutletvalue(event);
//                     getoutletMasterList(event?.value);
//                     setPaymentfetchitem([]);
//                   }}
//                 />
//               </div>

//               <div class="col-sm col-md-4 form-group" style={{ padding: "inherit" }}>
//                 <label as="a" variant="badge badge-rounded badge-danger">
//                   Restaurant
//                 </label>
//                 <Select
//                   options={outletMasterlist}
//                   value={restarantvalue}
//                   closeMenuOnSelect={false}
//                   search
//                   name="stateCode"
//                   placeholder="Choose"
//                   autoComplete="off"
//                   onChange={(event) => {
//                     setRestarantvalue(event);
//                     getpaymentmasterlist(event?.value)
//                     console.log(" getpaymentmasterlist", getpaymentmasterlist);
//                   }}
//                 />
//               </div>
//    </Card.Header>

//    <Card.Body className="scroll-tbl-fix-header">
//               {/* <input
//                 type="text" placeholder="Search Menu item/tag"
//                 style={{
//                   marginBottom: "14px",
//                   marginLeft: "400px",
//                   border: "2px solid #3abd4a", borderRadius: "12px", padding: "5px",

//                 }}
//             //     onChange={(e) => {
//             //       searchFilterMenuListMaster(e.target.value);
//             //     }}
//                /> */}

//               <Table responsive stripped>
//                 <br />
//                 <thead>
//                   <tr>
//                     <th>
//                       <strong>Payment Id </strong>
//                     </th>
//                     <th>
//                       <strong>Payment Method</strong>
//                     </th>

//                     <th>
//                       <strong>Payment Status</strong>
//                     </th>   

//                      <th>
//                       <strong>Action</strong>
//                     </th>         
//                   </tr>
//                 </thead>
//                 <tbody>
//                     {paymentfetchitem && 
//                     paymentfetchitem.map ( (items) =>{
//                         return (
//                             <>
//                               <tr>
//                                 <td>{items.paymentId}</td>
//                                 <td>{items.paymentMethodName}</td>
                                
//                                 <td>{items.paymentStatus}</td>
                        
                                
    
                        
                                
//                               </tr>
//                             </>
//                           );
//                         })}
    
//                       { paymentfetchitem?.length <= 0 ? (
//                           <div style={{ color: "red",textAlign:'center'}}> No Data Found </div>
//                         ):  setPaymentfetchitem}
//                 </tbody>
  
               
//               </Table>
//             </Card.Body>

   
//    </Card>

// </div>
// </>

//   )
// }

// export default ManagePaymentMethods